import script from "./ImgWrapper.vue?vue&type=script&lang=js"
export * from "./ImgWrapper.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__